import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import Controls from '@stories/Components/Carousels/Carousel/Controls/Controls';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import FullWidthCarouselStyles from '@stories/Components/Carousels/FullWidthCarousel/FullWidthCarousel.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --visibleItems: 1;
  --itemGutter: 8px;
  overflow-x: hidden;

  @media ${from(Device.Tablet)} {
    --visibleItems: 2;
  }

  ${SectionWrapperStyles.SiteWide} {
    position: relative;
  }
`;
const Title = styled.h2 `
  ${h2};
  max-width: 880px;
  margin-left: auto;
  margin-right: auto;
`;
const Footer = styled.div `
  ${contentStyles};
  max-width: 880px;
  margin: ${fluid(30, 60)} auto 0;
`;
const Track = styled(MotionTrack) `
  max-width: 992px;
  margin: 0 auto;
  overflow-x: hidden;
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems));
  padding: var(--itemGutter);
`;
const PaginationWrapper = styled.div `
  margin: 14px 0 0;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0.5rem;
  align-items: center;
`;
const Pagination = styled.div `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 3 / span 8;
  }
`;
const StyledControls = styled(Controls) `
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  max-width: 1096px;
  pointer-events: none;
  transform: translate(-50%, -50%) translateY(-17px);
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    pointer-events: auto;
  }
`;
const Button = styled(FullWidthCarouselStyles.Button) ``;
export const USPCarouselStyles = {
    Button,
    Container,
    Controls: StyledControls,
    Footer,
    Item,
    Pagination,
    PaginationWrapper,
    Title,
    Track,
};
